import styleInject from '../../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".Skeleton-module_headerTitle__XJhN3 {\n  width: 120px;\n  height: 26px;\n  border-radius: 3px;\n  background-color: #f5f6f8;\n}\n\n.Skeleton-module_footerTitle__tHaj7 {\n  width: 142px;\n  height: 24px;\n  border-radius: 3px;\n  background-color: #f5f6f8;\n}\n@media (min-width: 1000px) {\n  .Skeleton-module_footerTitle__tHaj7 {\n    width: 180px;\n  }\n}";
var styles = {"headerTitle":"Skeleton-module_headerTitle__XJhN3","footerTitle":"Skeleton-module_footerTitle__tHaj7"};
styleInject(css_248z);

export { styles as default };
